import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router doesn't reset scroll position on navigation the way a
// traditional multi-page site does — without this, navigating from a tall
// admin page (e.g. Hierarchy Management, scrolled halfway down) to a short
// one (e.g. an empty Approvals list) leaves the browser at the same pixel
// scroll offset, so AdminSidebar and the content card appear to have
// jumped up past the top of the new, shorter page instead of starting
// there like a fresh page normally would.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
